import { Button, Typography } from "@mui/material";
import { ResponsiveRow } from "../../../constants/layout.constants";
import { ModalAcceptButton } from "../../../constants/component.constants";
import FilterResults from "../../modals/listings/filterResults";
import { useCallback, useEffect, useState } from "react";
import { setDefaults, fromAddress } from "react-geocode";
import { isEmptyString, isNullUndefined } from "../../../util/util";
import { useLocation, useNavigate } from "react-router-dom";
import { LocationOn } from "@mui/icons-material";
import { SearchBox } from "@mapbox/search-js-react";

export default function LandingExploreBar(props) {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const [location, setLocation] = useState(null);
  const [searchedLocation, setSearchedLocation] = useState(
    props?.searchedLocation || "",
  );
  const [locationInput, setLocationInput] = useState("");

  const mapBoxAccessToken =
    "pk.eyJ1IjoidmlsbGFzb2Z0LWRldiIsImEiOiJjbWU5cHcyMGEwdmFiMmpzaDlyc25lenUxIn0.qlbJAtKO4ahDBe8mnDC8Ug";

  const getCoordinates = useCallback(async (locationName) => {
    try {
      const { results } = await fromAddress(locationName);
      if (!results || !results[0]) return;

      const bounds = results[0].geometry.bounds;
      props.setBounds(bounds);
      const { lat, lng } = results[0].geometry.location;
      props.setCenter({ lat, lng });
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    setDefaults({
      key: "AIzaSyAi5vlmbshza2_JkvFmF7w2EHmP0Ez12GY",
      language: "en",
      region: "KE", // specifying kenya but can default to global by removing the reqion
    });
  }, []);

  useEffect(() => {
    if (routeLocation.state && routeLocation.state.locationName) {
      const locName = routeLocation.state.locationName;
      setSearchedLocation(locName);
      setLocationInput(locName);
    }
  }, [routeLocation.state]);

  useEffect(() => {
    if (!isEmptyString(searchedLocation)) {
      getCoordinates(searchedLocation);
      setLocation(searchedLocation);
      navigate(routeLocation.pathname, {
        replace: true,
        state: {
          locationName: searchedLocation,
          budget: { min: props?.priceMin, max: props?.priceMax },
          propertyType: props?.selectedPropertyType,
        },
      });
    } else {
      navigate(routeLocation.pathname, { replace: true, state: {} });
    }
  }, [getCoordinates, searchedLocation]);

  useEffect(() => {
    let isMounted = true;
    const delayDebounceFn = setTimeout(() => {
      if (isMounted) {
        setSearchedLocation(locationInput);
      }
    }, 1000);
    return () => {
      isMounted = false;
      clearTimeout(delayDebounceFn);
    };
  }, [locationInput]);

  const handleSearchBoxChange = (location) => {
    setLocationInput(location);
  };

  const handleCloseSearch = () => {
    props.setReLocate(true);
    setSearchedLocation("");
    setLocation(null);
  };

  const mapBoxSearchBoxTheme = {
    variables: {
      colorPrimary: "#037171",
      colorBackgroundHover: "#2d9f93",
      colorPrimaryActive: "#037171",
      borderRadius: "10px",
      padding: "10px 10px",
      lineHeight: "1.4",
    },
    cssText: `
            .mapboxgl-ctrl-geocoder--icon-search {
                color: #037171;
            }
        `,
  };

  return (
    <ResponsiveRow
      sx={{
        width: "100%",
        height: "fit-content",
        backgroundColor: "#fff",
        flexDirection: "column",
        top: "100px",
        right: 0,
        margin: 0,
      }}
    >
      <ResponsiveRow
        sx={{
          flexDirection: "column",
          width: "100%",
          height: "auto",
          padding: "5px 20px",
        }}
      >
        <ResponsiveRow
          sx={{
            flexDirection: "column",
            width: "100%",
            height: "auto",
            padding: "5px 20px",
          }}
        >
          <ResponsiveRow
            sx={{
              width: "100%",
              padding: 0,
              justifyContent: { xs: "flex-start", lg: "space-between" },
              flexWrap: { xS: "wrap", lg: "nowrap" },
            }}
          >
            <Typography
              variant="h4"
              sx={{ color: "#037171", width: "100%", marginBottom: "10px" }}
            >
              Showing listing in:
            </Typography>
            <ModalAcceptButton
              sx={{
                fontSize: ".9rem",
                backgroundColor: "#009F93",
                width: { xs: "100%", lg: "150px" },
                padding: "5px",
                height: "auto",
              }}
              onClick={props.handleFilterModal}
            >
              Filter Results
            </ModalAcceptButton>
            {props.openFilterModal && (
              <FilterResults
                openModal={props.openFilterModal}
                closeModal={props.handleFilterModal}
                noOfBedsChanged={props.noOfBedsChanged}
                noOfBathsChanged={props.noOfBathsChanged}
                sqftMinChanged={props.sqftMinChanged}
                sqftMaxChanged={props.sqftMaxChanged}
                priceMinChanged={props.priceMinChanged}
                priceMaxChanged={props.priceMaxChanged}
                onPropertyTypeChange={props.onPropertyTypeChange}
                onListingTypeChange={props.onListingTypeChange}
                listingTypes={props.listingTypes}
                propertyTypes={props.propertyTypes}
                noOfBeds={props.noOfBeds}
                noOfBaths={props.noOfBaths}
                sqftMin={props.sqftMin}
                sqftMax={props.sqftMax}
                priceMin={props.priceMin}
                priceMax={props.priceMax}
                selectedPropertyType={props.selectedPropertyType}
                selectedListingType={props.selectedListingType}
                applyFilterClicked={props.applyFilterClicked}
                clearFilter={props.clearFilter}
              />
            )}
          </ResponsiveRow>
        </ResponsiveRow>
        {!isNullUndefined(location) && (
          <Button
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "13px",
              padding: "5px 7px",
              margin: { xs: "10px auto", lg: "10px" },
              backgroundColor: "#efefef",
              color: "#afafaf",
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: "red",
                color: "#fff",
              },
            }}
            onClick={handleCloseSearch}
          >
            <LocationOn sx={{ marginRight: "5px", color: "#009F93" }} />
            {location}
          </Button>
        )}

        <SearchBox
          placeholder="Search for a different location..."
          accessToken={mapBoxAccessToken}
          options={{
            language: "en",
            country: "ke", // Limit to kenya only. Remove this line if you want to search globally
          }}
          value={locationInput}
          interceptSearch={(value) => (value.length > 2 ? value : null)}
          onChange={(d) => handleSearchBoxChange(d)}
          onRetrieve={(results) => {
            handleSearchBoxChange(results?.features[0]?.properties?.name);
          }}
          showResultList
          showResultListOnFocus
          theme={mapBoxSearchBoxTheme}
        />
      </ResponsiveRow>
    </ResponsiveRow>
  );
}
